import { render, staticRenderFns } from "./officeSuppliesDetails.vue?vue&type=template&id=e27f8788&scoped=true"
import script from "./officeSuppliesDetails.vue?vue&type=script&lang=js"
export * from "./officeSuppliesDetails.vue?vue&type=script&lang=js"
import style0 from "./officeSuppliesDetails.vue?vue&type=style&index=0&id=e27f8788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27f8788",
  null
  
)

export default component.exports